import {TAGGING_FETCHED} from "@/redux/reducers/responsive/actionsTypes";
import {getTrackingDataByIdentify} from '@/services/trackingServices'
import {ThunkResult} from "@/models/common/core/ThunkResult";
import {TAGGING_FETCHED_TYPES} from "@/redux/reducers/responsive/tracking/trackingTypes";
export const getTrackingData = (identify: any): ThunkResult<TAGGING_FETCHED_TYPES> => (dispatch) => {
    getTrackingDataByIdentify(identify)
        .then(response => {
            dispatch({
                type: TAGGING_FETCHED,
                payload: {
                    headerTrackingFlow: response.headerTrackingFlow,
                    footerTrackingFlow: response.footerTrackingFlow,
                }
            });
        })
        .catch((error) => {
            console.log(error);
        })
}